"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserRTC = void 0;
var tslib_1 = require("tslib");
var Subscribe_1 = require("../shared-utils/Subscribe");
var RTCProtocol_1 = require("../typings/RTCProtocol");
var trtc_js_sdk_1 = (0, tslib_1.__importDefault)(require("trtc-js-sdk"));
var uuid_1 = require("../shared-utils/uuid");
var BrowserRTC = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(BrowserRTC, _super);
    function BrowserRTC(options) {
        var _this = _super.call(this) || this;
        _this.type = RTCProtocol_1.RTCType.realsee;
        _this.joined = false;
        _this.micro = false;
        _this.voiceId = '';
        _this._getVoiceSign = function () {
            throw new Error('方法 getVoiceSign 未实现');
        };
        _this.$dom = document.createElement('div');
        _this._trtc = {
            client: null,
            stream: null,
        };
        _this.join = function (options) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var createClientOptions, result;
            var _this = this;
            var _a;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.emit('joinWillStart');
                        return [4 /*yield*/, this._getVoiceSign({
                                voiceId: options.voiceId,
                                roomId: options.roomId,
                                userId: options.userId,
                            })
                            // 1.  创建client
                        ];
                    case 1:
                        createClientOptions = _b.sent();
                        // 1.  创建client
                        this._trtc.client = trtc_js_sdk_1.default.createClient((0, tslib_1.__assign)({ mode: 'rtc' }, createClientOptions));
                        // @ts-expect-error
                        (_a = this._trtc.client) === null || _a === void 0 ? void 0 : _a.enableAudioVolumeEvaluation();
                        // 2. 订阅事件
                        this._registerRtcEvent();
                        return [4 /*yield*/, new Promise(function (resolve) {
                                var _a;
                                (_a = _this._trtc.client) === null || _a === void 0 ? void 0 : _a.join({ roomId: Number(options.voiceId) }).then(function () { return resolve(true); }).catch(function () { return resolve(false); });
                            })];
                    case 2:
                        result = _b.sent();
                        this.joined = result;
                        if (!result)
                            return [2 /*return*/, false
                                // 4. 创建本地流
                            ]; // 进房失败
                        // 4. 创建本地流
                        this._trtc.stream = trtc_js_sdk_1.default.createStream({ userId: createClientOptions.userId, audio: true, video: false });
                        return [4 /*yield*/, new Promise(function (resolve) {
                                var _a;
                                (_a = _this._trtc.stream) === null || _a === void 0 ? void 0 : _a.initialize().then(function () { return resolve(true); }).catch(function () { return resolve(false); });
                            })
                            // 6. 发布本地流
                        ];
                    case 3:
                        // 5. 初始化本地流
                        result = _b.sent();
                        return [4 /*yield*/, new Promise(function (resolve) {
                                var _a;
                                (_a = _this._trtc.client) === null || _a === void 0 ? void 0 : _a.publish(_this._trtc.stream).then(function () { return resolve(true); }).catch(function () { return resolve(false); });
                            })];
                    case 4:
                        // 6. 发布本地流
                        result = _b.sent();
                        this.joined = result;
                        if (this.joined)
                            this.emit('joined');
                        return [2 /*return*/, result];
                }
            });
        }); };
        _this._handleStreamAdded = function (event) {
            var _a;
            var remoteStream = event.stream;
            console.log('远端流增加: ' + remoteStream.getId());
            //订阅远端流
            (_a = _this._trtc.client) === null || _a === void 0 ? void 0 : _a.subscribe(remoteStream);
        };
        _this._handleStreamSubscribed = function (event) {
            var remoteStream = event.stream;
            console.log('远端流订阅成功：' + remoteStream.getId());
            var playId = remoteStream.getId();
            var domId = "rs-rtc-remote_stream-" + playId;
            var dom = document.createElement('div');
            dom.id = domId;
            _this.$dom.appendChild(dom);
            // 播放远端流
            remoteStream.play(domId);
        };
        _this._getVoiceSign = options.getVoiceSign;
        _this._initParentDom();
        return _this;
    }
    BrowserRTC.prototype._initParentDom = function () {
        this.$dom.id = "rs-rtc-" + (0, uuid_1.uuid)();
        this.$dom.style.display = 'none';
        document.body.appendChild(this.$dom);
    };
    BrowserRTC.prototype.quit = function () {
        var _this = this;
        return new Promise(function (resolve) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var _this = this;
            var _a, _b;
            return (0, tslib_1.__generator)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.joined = false;
                        if (!this._trtc.stream) return [3 /*break*/, 2];
                        return [4 /*yield*/, ((_a = this._trtc.client) === null || _a === void 0 ? void 0 : _a.unpublish(this._trtc.stream))];
                    case 1:
                        _c.sent();
                        this._trtc.stream.stop();
                        this._trtc.stream.close();
                        this._trtc.stream = null;
                        _c.label = 2;
                    case 2:
                        (_b = this._trtc.client) === null || _b === void 0 ? void 0 : _b.leave().then(function () { return _this._trtc.client = null; }).then(function () { return resolve(true); }).catch(function () { return resolve(false); });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    BrowserRTC.prototype.detectMicro = function () {
        return new Promise(function (resolve) {
            var rule = { audio: true, video: false };
            try {
                navigator.mediaDevices
                    .getUserMedia(rule)
                    .then(function () { return resolve(true); })
                    .catch(function () { return resolve(false); });
            }
            catch (e) {
                console.error(e);
                resolve(false);
            }
        });
    };
    BrowserRTC.prototype.toggleMicro = function (flag) {
        var _a, _b, _c, _d;
        return Promise.resolve((flag ? (_b = (_a = this._trtc) === null || _a === void 0 ? void 0 : _a.stream) === null || _b === void 0 ? void 0 : _b.unmuteAudio() : (_d = (_c = this._trtc) === null || _c === void 0 ? void 0 : _c.stream) === null || _d === void 0 ? void 0 : _d.muteAudio()) || false);
    };
    BrowserRTC.prototype.shock = function () {
        throw new Error('Method not implemented.');
    };
    BrowserRTC.prototype._registerRtcEvent = function () {
        var _this = this;
        var _a, _b, _c, _d;
        (_a = this._trtc.client) === null || _a === void 0 ? void 0 : _a.on('stream-added', this._handleStreamAdded);
        (_b = this._trtc.client) === null || _b === void 0 ? void 0 : _b.on('stream-subscribed', this._handleStreamSubscribed);
        // @ts-expect-error
        (_c = this._trtc.client) === null || _c === void 0 ? void 0 : _c.on('audio-volume', function (event) { return _this.emit('userVolumes', event.result); });
        (_d = this._trtc.client) === null || _d === void 0 ? void 0 : _d.on('error', function (event) { return _this.emit('error', event); });
    };
    return BrowserRTC;
}(Subscribe_1.Subscribe));
exports.BrowserRTC = BrowserRTC;
//# sourceMappingURL=BrowserRTC.js.map